import { useEffect, useState } from "react";
import { Clock, Truck } from "lucide-react";

/**
 * Live levertijd-counter — toont hoeveel uur/min nog tot 15u00 (cutoff voor zelfde-dag-snijden).
 * Op weekend toont het "Maandag" als verwerkingsdag.
 */
export default function DeliveryCountdown({ cutoffHour = 15 }) {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const t = setInterval(() => setNow(new Date()), 60000); // refresh per minuut
        return () => clearInterval(t);
    }, []);

    const day = now.getDay(); // 0=Sun ... 6=Sat
    const hour = now.getHours();
    const isWeekend = day === 0 || day === 6;

    const cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);
    const passed = now > cutoff;

    let label, sub;
    if (isWeekend) {
        label = "Verwerking maandag";
        sub = "Bestel nu — start direct maandagochtend";
    } else if (passed) {
        label = "Verwerking morgen";
        sub = "Bestel vandaag — start morgenochtend";
    } else {
        const diffMs = cutoff - now;
        const h = Math.floor(diffMs / 3600000);
        const m = Math.floor((diffMs % 3600000) / 60000);
        label = `Bestel binnen ${h}u ${m.toString().padStart(2, "0")}m`;
        sub = "→ wij snijden vandaag nog";
    }

    return (
        <div data-testid="delivery-countdown" className="inline-flex items-center gap-3 px-4 py-2.5 rounded-full" style={{ background: "white", border: "1px solid var(--border)" }}>
            <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ background: passed || isWeekend ? "var(--bg-warm)" : "var(--rose-tint)" }}>
                {passed || isWeekend
                    ? <Truck size={16} style={{ color: "var(--text-2)" }} />
                    : <Clock size={16} style={{ color: "var(--rose-deep)" }} />}
            </span>
            <div className="leading-tight">
                <p className="text-xs font-bold" style={{ color: "var(--text)" }}>{label}</p>
                <p className="text-[10px]" style={{ color: "var(--text-3)" }}>{sub}</p>
            </div>
        </div>
    );
}
